// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="translate(3.000000, 3.000000)">
				<path d="M8.62564893,4.99109075 C8.62079988,4.99103132 8.61593204,4.99099171
				8.61108298,
				4.99093228 C8.61108298,4.5751827 8.61877005,4.15921524 8.60884641,3.74372317
				C8.59946781,3.35174316 8.5854845,2.95877275 8.5477446,2.56903104 C8.51163984,
				2.19618554 8.3869929,1.85259641 8.14818652,1.56278594 C7.81409063,1.15735632
				7.37312766,0.986532345 6.88487705,0.955116897 C6.32926596,0.919383311 5.77173781,
				0.91058857 5.21488628,0.903418083 C4.66074119,0.896307021 4.10627658,0.898703785
				3.55220667,0.910410298 C3.1802957,0.918254256 2.8074262,0.934912763 2.43760145,
				0.974687176 C2.08384623,1.01271849 1.7578133,1.14408497 1.48284577,1.39578491
				C1.09815435,1.74789146 0.936068229,2.21262616 0.906259719,2.72717791 C0.872353948,
				3.31276106 0.864009069,3.90034482 0.857224156,4.48721549 C0.850458037,5.07123381
				0.852732205,5.65558887 0.863839916,6.23952796 C0.871282646,6.63146835 0.88708905,
				7.02445856 0.924828954,7.41420027 C0.960914919,7.78702597 1.08556185,8.1306349
				1.32438704,8.42044537 C1.65848292,8.825875 2.09944589,8.99669897 2.58769651,
				9.02809461 C3.14330759,9.06382819 3.70083574,9.07264274 4.25768728,9.07979342
				C4.81183237,9.08690449 5.36640974,9.08710256 5.92034809,9.07208812 C6.32941632,
				9.06101546 6.74254423,9.05275554 7.1453726,8.98612151 C7.83378755,8.87220585
				8.29965359,8.45154389 8.48498885,7.73140517 C8.54505695,7.49808704 8.5765194,
				7.25145795 8.58503343,7.00950354 C8.60869605,6.33708223 8.61343233,5.66394783
				8.62564893,4.99109075 M-5.44633194e-06,6.63566764 L-5.44633194e-06,3.34754387
				C0.00521950059,3.31638592 0.0142221969,3.28534683 0.0151055513,3.25405023
				C0.0260065197,2.8682305 0.0424707409,2.48306444 0.132196988,2.10629695 C0.334616694,
				1.25627734 0.802343418,0.637773337 1.57159469,0.287211804 C1.98872588,0.0971146726
				2.43198181,0.0418702316 2.88115809,0.0225178405 C2.97968029,0.018278934 3.07793937,
				0.00768166761 3.17631121,-3.82650163e-06 L6.29624355,-3.82650163e-06 C6.32582652,
				0.00550279042 6.35527793,0.0149908102 6.38497367,0.015921785 C6.75105826,
				0.0274104102 7.11650383,0.0447621959 7.47401801,0.139325466 C8.2805769,0.352657352
				8.8674061,0.845618414 9.20005479,1.656339 C9.38042823,2.09595719 9.43273408,
				2.56310846 9.45119055, 3.03647944 C9.45525022,3.14031284 9.46528663,3.24386893
				9.4725602,3.34754387 L9.4725602,6.63566764 C9.46733526,6.66684539 9.45833256,
				6.69788449 9.457468,6.72918109 C9.44662342,7.11500081 9.43004643,7.50014707
				9.34035777,7.87691455 C9.13797565,8.72695397 8.67021134,9.34543817 7.90096007,
				9.69601951 C7.48382888,9.88611664 7.04057295,9.94124223 6.59139667,9.96069367
				C6.49289326,9.96495238 6.39463419,9.97554965 6.29624355,9.98321533 L3.17631121,
				9.98321533 C3.14674703,9.97770872 3.11729562,9.9682207 3.08759988,9.96730953
				C2.72151529,9.95588033 2.35606972,9.93840969 1.99857434,9.84388604 C1.19201545,
				9.63059377 0.605167453,9.13763271 0.272518764,8.32689231 C0.0921453263,7.88727412
				0.039726704,7.42014266 0.0213642107,6.94673207 C0.0173421293,6.84291848
				0.00728692564,6.73934258 -5.44633194e-06,6.63566764" />
				<path d="M7.17031515,4.99377869 C7.16980769,6.41315872 6.07873352,7.55891139
				4.72951314,7.55687117 C3.38784826,7.55483095 2.30130363,6.40553265 2.30224337,
				4.98942093 C2.3032019,3.56956551 3.39410692,2.42401092 4.74302658,2.42634826
				C6.08508615,2.42870541 7.17082261,3.57711235 7.17031515,4.99377869 Z M7.25933659,
				1.72655629 C7.57741933,1.72505089 7.83361088,1.99202277 7.83432508,2.32578714
				C7.83505808,2.65947228 7.57959952,2.93012844 7.26330229,2.9307821 C6.94988065,
				2.93145557 6.69049399,2.65667935 6.69167806,2.32525232 C6.69286213,1.9973313
				6.94818912,1.72804189 7.25933659,1.72655629 Z M4.73496362,6.65216174 C5.59702348,
				6.65220135 6.3110745,5.90876845 6.31190147,5.01031835 C6.31274724,4.08479074
				5.61307422,3.33175097 4.75167218,3.33105769 C3.8702725,3.3303446 3.16078861,
				4.06912263 3.16067584,4.98773726 C3.16056307,5.90625284 3.86602488,6.65212212
				4.73496362,6.65216174 Z" />
			</g>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Instagram.js